(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8160],{

/***/ 44174:
/***/ (function(module) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),

/***/ 81119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 57406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    last = __webpack_require__(10928),
    parent = __webpack_require__(40292),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 55189:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(44174),
    baseAggregator = __webpack_require__(81119),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),

/***/ 82710:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPlainObject = __webpack_require__(68630);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 99021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(85564),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 51004:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813),
    isArrayLike = __webpack_require__(98612),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 40292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSlice = __webpack_require__(14259);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 85564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 68630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    getPrototype = __webpack_require__(85924),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 24350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    createAggregator = __webpack_require__(55189);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 66604:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    baseForOwn = __webpack_require__(47816),
    baseIteratee = __webpack_require__(67206);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ 57557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseClone = __webpack_require__(85990),
    baseUnset = __webpack_require__(57406),
    castPath = __webpack_require__(71811),
    copyObject = __webpack_require__(98363),
    customOmitClone = __webpack_require__(82710),
    flatRest = __webpack_require__(99021),
    getAllKeysIn = __webpack_require__(46904);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 89734:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078),
    baseOrderBy = __webpack_require__(82689),
    baseRest = __webpack_require__(5976),
    isIterateeCall = __webpack_require__(51004);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 60365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ setAdaOnPage; },
/* harmony export */   "It": function() { return /* binding */ getContactDetailsUrl; },
/* harmony export */   "P1": function() { return /* binding */ getContactDetailsHubspotFields; },
/* harmony export */   "Rb": function() { return /* binding */ getSmallBusinessesHSFields; },
/* harmony export */   "Wz": function() { return /* binding */ getContactDetails; },
/* harmony export */   "Z9": function() { return /* binding */ getBAMRedirectUrlWithQueryParams; },
/* harmony export */   "aC": function() { return /* binding */ handleContactDetailsInfoOnPage; }
/* harmony export */ });
/* unused harmony exports transformDataToAdaFormat, setBookAMeetingInfoOnPage */
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10092);
/* harmony import */ var services_cookies_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67798);
/* harmony import */ var constants_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13019);
/* harmony import */ var constants_cookies__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constants_cookies__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var client_services_hubspot_service_hubspot_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24660);
/* harmony import */ var client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22638);
/* harmony import */ var services_contact_sales__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94445);
/* harmony import */ var services_bigbrain_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95470);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64487);
/* harmony import */ var constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65023);
/* harmony import */ var segments_desktop_embedded_layouts_book_a_meeting_embedded_book_a_meeting_embedded_consts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82420);
/* harmony import */ var segments_desktop_embedded_layouts_contact_options_embedded_consts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25279);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var BOOK_A_MEETING_NAME_QUERY_PARAM_KEY = "name";
var DEFAULT_TIMEOUT = 10000; // 10 seconds
var CHATBOT_PAGE_URI = "/lp/quick-assistance";
var FIELDS_MAPPING = {
    firstname: "contactSalesFirstName",
    lastname: "contactSalesLastName",
    email: "contactSalesEmail",
    jobtitle: "contactSalesJobTitle",
    phone: "contactSalesPhone",
    company: "contactSalesCompany",
    company_size__c: "contactSalesCompanySize",
    product_question_hs_forms: "contactSalesProductQuestion",
    how_can_our_consulting_team_help_you: "contactSalesOpenText"
};
var transformDataToAdaFormat = function(input) {
    var result = {};
    input.forEach(function(item) {
        var name = item.name, value = item.value;
        var mappedKey = FIELDS_MAPPING[name];
        if (mappedKey) {
            var _value_;
            if (Array.isArray(value) && ((_value_ = value[0]) === null || _value_ === void 0 ? void 0 : _value_.value)) {
                result[mappedKey] = value[0].value;
            } else if (value === null || value === void 0 ? void 0 : value.value) {
                result[mappedKey] = value.value;
            } else {
                result[mappedKey] = value;
            }
        }
    });
    return result;
};
// TODO: remove if Amanda succeed
var getMeetingCalenderDetails = function() {
    var _ref = _async_to_generator(function(formData, enrichmentCS) {
        var timeout, startTime, clientTimezoneOffset, bamCalenderResponse, error;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    timeout = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : DEFAULT_TIMEOUT;
                    startTime = performance.now();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    clientTimezoneOffset = new Date().getTimezoneOffset();
                    return [
                        4,
                        (0,services_contact_sales__WEBPACK_IMPORTED_MODULE_4__/* .getCalendarLink */ .I9)(_object_spread_props(_object_spread({}, formData), {
                            cs: enrichmentCS,
                            clientTimezoneOffset: clientTimezoneOffset
                        }), timeout)
                    ];
                case 2:
                    bamCalenderResponse = _state.sent();
                    (0,services_bigbrain_service__WEBPACK_IMPORTED_MODULE_5__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.BOOK_A_MEETING_ELIGIBILITY_RESPONSE_TIME, {
                        kind: Math.round(performance.now() - startTime),
                        info1: !!(bamCalenderResponse === null || bamCalenderResponse === void 0 ? void 0 : bamCalenderResponse.calendarLink)
                    });
                    return [
                        2,
                        bamCalenderResponse
                    ];
                case 3:
                    error = _state.sent();
                    if ((error === null || error === void 0 ? void 0 : error.name) === "AbortError") {
                        (0,services_bigbrain_service__WEBPACK_IMPORTED_MODULE_5__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.BOOK_A_MEETING_ELIGIBILITY_TIMEOUT_EXCEEDED, {
                            kind: timeout
                        });
                        return [
                            2,
                            null
                        ];
                    }
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .captureException */ .Tb(error);
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .captureMessage */ .uT("Error occurred while getting BAM link : ".concat((error === null || error === void 0 ? void 0 : error.message) || error));
                    (0,services_bigbrain_service__WEBPACK_IMPORTED_MODULE_5__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.BOOK_A_MEETING_ELIGIBILITY_RESPONSE_ERROR, {
                        kind: (error === null || error === void 0 ? void 0 : error.message) || error,
                        info1: Math.round(performance.now() - startTime)
                    });
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getMeetingCalenderDetails(formData, enrichmentCS) {
        return _ref.apply(this, arguments);
    };
}();
var getContactDetails = function() {
    var _ref = _async_to_generator(function(formData, enrichmentCS) {
        var timeout, normalizeFields, startTime, clientTimezoneOffset, contactSalesLinkResponse, error;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    timeout = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : DEFAULT_TIMEOUT;
                    normalizeFields = normalizeHubspotFields(formData);
                    startTime = performance.now();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    clientTimezoneOffset = new Date().getTimezoneOffset();
                    return [
                        4,
                        (0,services_contact_sales__WEBPACK_IMPORTED_MODULE_4__/* .getContactSalesLink */ .Yx)(_object_spread_props(_object_spread({}, normalizeFields), {
                            cs: enrichmentCS,
                            clientTimezoneOffset: clientTimezoneOffset
                        }), timeout)
                    ];
                case 2:
                    contactSalesLinkResponse = _state.sent();
                    (0,services_bigbrain_service__WEBPACK_IMPORTED_MODULE_5__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.GET_CONTACT_DETAILS_ELIGIBILITY_RESPONSE_TIME, {
                        kind: Math.round(performance.now() - startTime),
                        info1: !!(contactSalesLinkResponse === null || contactSalesLinkResponse === void 0 ? void 0 : contactSalesLinkResponse.calendarLink)
                    });
                    return [
                        2,
                        contactSalesLinkResponse
                    ];
                case 3:
                    error = _state.sent();
                    if ((error === null || error === void 0 ? void 0 : error.name) === "AbortError") {
                        (0,services_bigbrain_service__WEBPACK_IMPORTED_MODULE_5__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.GET_CONTACT_DETAILS_ELIGIBILITY_TIMEOUT_EXCEEDED, {
                            kind: timeout
                        });
                        return [
                            2,
                            null
                        ];
                    }
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .captureException */ .Tb(error);
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .captureMessage */ .uT("Error occurred while getting contact links : ".concat((error === null || error === void 0 ? void 0 : error.message) || error));
                    (0,services_bigbrain_service__WEBPACK_IMPORTED_MODULE_5__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.GET_CONTACT_DETAILS_ELIGIBILITY_RESPONSE_ERROR, {
                        kind: (error === null || error === void 0 ? void 0 : error.message) || error,
                        info1: Math.round(performance.now() - startTime)
                    });
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getContactDetails(formData, enrichmentCS) {
        return _ref.apply(this, arguments);
    };
}();
var getBAMRedirectUrlWithQueryParams = function(bookAMeetingUrl, firstName) {
    try {
        if (!firstName) return bookAMeetingUrl;
        var url = new URL(bookAMeetingUrl, window.location.origin);
        url.searchParams.set(BOOK_A_MEETING_NAME_QUERY_PARAM_KEY, firstName);
        return url.toString();
    } catch (error) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .captureMessage */ .uT("error occur on calculating BAM redirect url with nam query param, ".concat(error.message));
        return bookAMeetingUrl;
    }
};
var setAdaOnPage = function(formData) {
    (0,services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)(constants_cookies__WEBPACK_IMPORTED_MODULE_1__.CONTACT_SALES_FORM_DATA, transformDataToAdaFormat(formData));
};
var getSmallBusinessesHSFields = function() {
    var smallBusinessesUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var hsFields = [];
    if (smallBusinessesUrl.endsWith(CHATBOT_PAGE_URI)) {
        hsFields.push({
            name: client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_3__/* .WEBSITE_BOT_HELP */ .aJ,
            value: true
        });
    }
    return hsFields;
};
// TODO: remove if Amanda succeed
var setBookAMeetingInfoOnPage = function() {
    var _ref = _async_to_generator(function(formData, enrichment, bookAMeetingUrl, timeout) {
        var disableRedirect, formFieldsObject, calendarDetails, firstName, _localStorage, _localStorage1, _localStorage2;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    disableRedirect = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : false;
                    if (!bookAMeetingUrl) return [
                        2,
                        null
                    ];
                    formFieldsObject = Object.fromEntries(formData.map(function(param) {
                        var name = param.name, value = param.value;
                        return [
                            name,
                            value
                        ];
                    }));
                    return [
                        4,
                        getMeetingCalenderDetails(formFieldsObject, enrichment === null || enrichment === void 0 ? void 0 : enrichment.cs, timeout)
                    ];
                case 1:
                    calendarDetails = _state.sent();
                    if (!(calendarDetails === null || calendarDetails === void 0 ? void 0 : calendarDetails.calendarLink)) return [
                        2,
                        null
                    ];
                    firstName = (0,client_services_hubspot_service_hubspot_service__WEBPACK_IMPORTED_MODULE_2__/* .getValueFromHSFields */ .wB)(formData, client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_3__/* .HUBSPOT_API_FIRSTNAME */ .uy);
                    if (!disableRedirect) {
                        ;
                        (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem(segments_desktop_embedded_layouts_book_a_meeting_embedded_book_a_meeting_embedded_consts__WEBPACK_IMPORTED_MODULE_6__/* .CHILIPIPER_URL */ .Yt, calendarDetails.calendarLink);
                        (_localStorage1 = localStorage) === null || _localStorage1 === void 0 ? void 0 : _localStorage1.setItem(segments_desktop_embedded_layouts_book_a_meeting_embedded_book_a_meeting_embedded_consts__WEBPACK_IMPORTED_MODULE_6__/* .CHILIPIPER_TIMEOUT */ .JF, calendarDetails === null || calendarDetails === void 0 ? void 0 : calendarDetails.calendarLinkTimeoutInMS);
                        (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem(segments_desktop_embedded_layouts_book_a_meeting_embedded_book_a_meeting_embedded_consts__WEBPACK_IMPORTED_MODULE_6__/* .CHILIPIPER_LINK_TIMESTAMP */ .yV, Date.now());
                    }
                    return [
                        2,
                        getBAMRedirectUrlWithQueryParams(bookAMeetingUrl, firstName)
                    ];
            }
        });
    });
    return function setBookAMeetingInfoOnPage(formData, enrichment, bookAMeetingUrl, timeout) {
        return _ref.apply(this, arguments);
    };
}();
var getContactDetailsUrl = function(bookAMeetingUrl, contactDetailsUrl, contactDetails) {
    var ref = contactDetails || {}, amandaCallLink = ref.amandaCallLink, calendarLink = ref.calendarLink;
    if (!calendarLink && !amandaCallLink) {
        return null;
    }
    if (contactDetailsUrl && amandaCallLink) {
        return contactDetailsUrl;
    }
    return bookAMeetingUrl;
};
var getContactDetailsHubspotFields = function(param) {
    var amandaCallLink = param.amandaCallLink, calendarLink = param.calendarLink;
    var hubspotFields = [];
    if (amandaCallLink) {
        hubspotFields.push({
            name: client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_3__/* .HUBSPOT_ELIGIBLE_FOR_GAC */ .Gm,
            value: true
        });
    }
    if (calendarLink) {
        hubspotFields.push({
            name: client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_3__/* .HUBSPOT_ELIGIBLE_FOR_BAM */ .AX,
            value: true
        });
    }
    return hubspotFields;
};
var handleAmandaLocalStorage = function(param, formData) {
    var amandaCallLink = param.amandaCallLink, amandaCallLinkExpirationInMS = param.amandaCallLinkExpirationInMS;
    var _localStorage, _localStorage1, _localStorage2;
    if (!amandaCallLink) {
        return;
    }
    var userEmail = (0,client_services_hubspot_service_hubspot_service__WEBPACK_IMPORTED_MODULE_2__/* .getValueFromHSFields */ .wB)(formData, client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_3__/* .HUBSPOT_API_EMAIL */ .dP);
    (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem(segments_desktop_embedded_layouts_contact_options_embedded_consts__WEBPACK_IMPORTED_MODULE_10__/* .AMANDA_CALL_LINK */ .nS, amandaCallLink);
    (_localStorage1 = localStorage) === null || _localStorage1 === void 0 ? void 0 : _localStorage1.setItem(segments_desktop_embedded_layouts_contact_options_embedded_consts__WEBPACK_IMPORTED_MODULE_10__/* .AMANDA_TIMOUT */ .I4, amandaCallLinkExpirationInMS);
    (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem(segments_desktop_embedded_layouts_contact_options_embedded_consts__WEBPACK_IMPORTED_MODULE_10__/* .EMAIL_FOR_HUBSPOT_AMANDA_REQUEST */ .VP, userEmail);
};
var handleBAMLocalStorage = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, calendarLink = ref.calendarLink, calendarLinkTimeoutInMS = ref.calendarLinkTimeoutInMS, formData = arguments.length > 1 ? arguments[1] : void 0;
    var _localStorage, _localStorage1, _localStorage2, _localStorage3;
    if (!calendarLink) {
        return;
    }
    var firstName = (0,client_services_hubspot_service_hubspot_service__WEBPACK_IMPORTED_MODULE_2__/* .getValueFromHSFields */ .wB)(formData, client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_3__/* .HUBSPOT_API_FIRSTNAME */ .uy);
    (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem(segments_desktop_embedded_layouts_book_a_meeting_embedded_book_a_meeting_embedded_consts__WEBPACK_IMPORTED_MODULE_6__/* .CHILIPIPER_URL */ .Yt, calendarLink);
    (_localStorage1 = localStorage) === null || _localStorage1 === void 0 ? void 0 : _localStorage1.setItem(segments_desktop_embedded_layouts_book_a_meeting_embedded_book_a_meeting_embedded_consts__WEBPACK_IMPORTED_MODULE_6__/* .CHILIPIPER_TIMEOUT */ .JF, calendarLinkTimeoutInMS);
    (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem(segments_desktop_embedded_layouts_book_a_meeting_embedded_book_a_meeting_embedded_consts__WEBPACK_IMPORTED_MODULE_6__/* .CHILIPIPER_LINK_TIMESTAMP */ .yV, Date.now());
    (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : _localStorage3.setItem(segments_desktop_embedded_layouts_contact_options_embedded_consts__WEBPACK_IMPORTED_MODULE_10__/* .USER_FIRST_NAME */ .zz, firstName);
};
var normalizeHubspotFields = function(formData) {
    var _formFieldsObject_phone;
    var formFieldsObject = Object.fromEntries(formData.map(function(param) {
        var name = param.name, value = param.value;
        return [
            name,
            value
        ];
    }));
    // Add + symbol to phone number if it doesn't already have it
    if (!(formFieldsObject === null || formFieldsObject === void 0 ? void 0 : (_formFieldsObject_phone = formFieldsObject.phone) === null || _formFieldsObject_phone === void 0 ? void 0 : _formFieldsObject_phone.startsWith("+"))) {
        formFieldsObject.phone = "+".concat(formFieldsObject.phone);
    }
    return formFieldsObject;
};
var handleContactDetailsInfoOnPage = function(contactDetails, formData) {
    handleAmandaLocalStorage(contactDetails || {}, formData);
    handleBAMLocalStorage(contactDetails || {}, formData);
};


/***/ }),

/***/ 95472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22638);
/* harmony import */ var client_services_hubspot_service_contact_form_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49228);


/* harmony default export */ __webpack_exports__["Z"] = ({
    portalId: "5945317",
    formId: client_services_hubspot_service_contact_form_config__WEBPACK_IMPORTED_MODULE_1__/* .CONTACT_SALES_HUBSPOT_FORM_ID */ .PD,
    source: client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_0__/* .leadSourceDefaultValue */ .Ts,
    withPrivacyNotice: true
});


/***/ }),

/***/ 78160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hubspot_contact_form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./client/services/hubspot-service/contact-form-config.js + 1 modules
var contact_form_config = __webpack_require__(49228);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-service.js + 1 modules
var hubspot_service = __webpack_require__(24660);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./constants/sales/campaigns.js
var campaigns = __webpack_require__(44363);
// EXTERNAL MODULE: ./segments/desktop/core-components/base-form/base-form.js + 5 modules
var base_form = __webpack_require__(17784);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./client/services/exceptions-handling-service/exceptions-handling-service.js
var exceptions_handling_service = __webpack_require__(53989);
// EXTERNAL MODULE: ./services/ab-tests/monetization-ab-tests-service.js + 2 modules
var monetization_ab_tests_service = __webpack_require__(46724);
// EXTERNAL MODULE: ./client/services/form-service/form-inputs.js + 18 modules
var form_inputs = __webpack_require__(5893);
// EXTERNAL MODULE: ./client/services/form-service/form-service.js
var form_service = __webpack_require__(25887);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
// EXTERNAL MODULE: ./node_modules/lodash/keyBy.js
var keyBy = __webpack_require__(24350);
var keyBy_default = /*#__PURE__*/__webpack_require__.n(keyBy);
// EXTERNAL MODULE: ./node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(66604);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(57557);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./services/contact-sales/index.js + 1 modules
var contact_sales = __webpack_require__(94445);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./segments/desktop/core-components/hubspot-contact-form/default-props.js
var default_props = __webpack_require__(95472);
;// CONCATENATED MODULE: ./segments/desktop/core-components/hubspot-contact-form/consts.js
var HUBSPOT_TO_LEAD_DATA_MAP = {
    first_name: "firstname",
    last_name: "lastname",
    email: "email",
    job_title: "jobtitle",
    phone: "phone",
    company_name: "company",
    company_size: "company_size__c",
    product: "product_question_hs_forms"
};

// EXTERNAL MODULE: ./client/services/form-service/form-constants.js
var form_constants = __webpack_require__(24065);
// EXTERNAL MODULE: ./client/services/contact-sales-service/contact-sales-service.js
var contact_sales_service = __webpack_require__(60365);
// EXTERNAL MODULE: ./contexts/loading-screen-context.js
var loading_screen_context = __webpack_require__(67413);
// EXTERNAL MODULE: ./contexts/types/loader-types.js
var loader_types = __webpack_require__(99534);
// EXTERNAL MODULE: ./contexts/system-config-context.js
var system_config_context = __webpack_require__(79760);
;// CONCATENATED MODULE: ./segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form.js







function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}































var HUBSPOT_INVALID_EMAIL_ERROR_TYPE = "INVALID_EMAIL";
var GARTNER_REPORT_URL = "https://www.gartner.com/doc/reprints?id=1-2AKZAKIR&ct=220714&st=sb";
var HubspotContactForm = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HubspotContactForm, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HubspotContactForm);
    function HubspotContactForm(props) {
        (0,_class_call_check/* default */.Z)(this, HubspotContactForm);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getFirstErrorMessageFromResponse", function(response) {
            var _response_errors_, _response_errors, _response_errors_1, _response_errors1;
            if ((response === null || response === void 0 ? void 0 : (_response_errors = response.errors) === null || _response_errors === void 0 ? void 0 : (_response_errors_ = _response_errors[0]) === null || _response_errors_ === void 0 ? void 0 : _response_errors_.errorType) === HUBSPOT_INVALID_EMAIL_ERROR_TYPE) {
                // Formatting Hubspot message into more user friendly one for known message types
                return "form.errors.invalidEmailError";
            }
            return response === null || response === void 0 ? void 0 : (_response_errors1 = response.errors) === null || _response_errors1 === void 0 ? void 0 : (_response_errors_1 = _response_errors1[0]) === null || _response_errors_1 === void 0 ? void 0 : _response_errors_1.message;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "convertValuesToHubspotFormat", function(formData) {
            var _props = _this.props, withPrivacyNotice = _props.withPrivacyNotice, formId = _props.formId, overrideCampaignId = _props.overrideCampaignId, formTitle = _props.formTitle, lastNameFirst = _props.lastNameFirst;
            var formConfig = (0,contact_form_config/* getContactFormConfigById */.Ty)({
                formId: formId,
                overrideCampaignId: overrideCampaignId,
                withPrivacyNotice: withPrivacyNotice,
                formTitle: formTitle,
                lastNameFirst: lastNameFirst
            });
            var convertedData = [];
            formData.forEach(function(inputField) {
                var inputConfig = (0,form_service/* getInputDataByName */.au)(formConfig, inputField.name);
                if (inputConfig.type === form_inputs/* inputTypes.MULTI_SELECT */.Je.MULTI_SELECT) {
                    if (Array.isArray(inputField.value)) {
                        var order = inputConfig.options.map(function(item) {
                            return item.value;
                        });
                        var sortedInputField = {
                            name: inputField.name,
                            // sort by the order of the options in the config
                            value: sortBy_default()(inputField.value, function(item) {
                                return order.indexOf(item.value);
                            })
                        };
                        convertedData.push({
                            name: sortedInputField.name,
                            value: sortedInputField.value.map(function(option) {
                                return option.value;
                            }).join(";")
                        });
                    } else {
                        convertedData.push({
                            name: inputField.name,
                            value: inputField.value.value
                        });
                    }
                } else {
                    convertedData.push(inputField);
                }
            });
            return convertedData;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "convertToLeadData", function(convertedFormData) {
            var leadData = {};
            Object.keys(HUBSPOT_TO_LEAD_DATA_MAP).forEach(function(key) {
                var hubspotKey = HUBSPOT_TO_LEAD_DATA_MAP[key];
                var field = convertedFormData.find(function(item) {
                    return item.name === hubspotKey;
                });
                if (field) {
                    leadData[key] = field.value;
                }
            });
            return leadData;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "sendHubspotStagingFormIfNeeded", function() {
            var _ref = _async_to_generator(function(portalId, formId, fields) {
                var testResponse, error, testSuccess;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(portalId != contact_form_config/* TEST_PORTAL_ID */.ND || formId != contact_form_config/* TEST_CONTACT_SALES_HUBSPOT_FORM_ID */.aC)) return [
                                3,
                                5
                            ];
                            testResponse = null;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0,hubspot_service/* sendHubspotForm */.Pw)(contact_form_config/* TEST_PORTAL_ID */.ND, contact_form_config/* TEST_CONTACT_SALES_HUBSPOT_FORM_ID */.aC, fields, false)
                            ];
                        case 2:
                            testResponse = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Error sending Hubspot test form:", error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            testSuccess = testResponse && !testResponse.status;
                            if (!testSuccess) {
                                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_TEST_SUBMIT_FAILED);
                            }
                            _state.label = 5;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(portalId, formId, fields) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getCSData", function() {
            var _ref = _async_to_generator(function(email, timeout) {
                var startTime, apiResponse, timeToResponse, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            startTime = performance.now();
                            return [
                                4,
                                (0,contact_sales/* isBC */.Cp)(email, timeout)
                            ];
                        case 1:
                            apiResponse = _state.sent();
                            timeToResponse = performance.now() - startTime;
                            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CONTACT_SALES_ENRICHEMNT_CALL_SUCCESS, {
                                kind: timeToResponse
                            });
                            return [
                                2,
                                apiResponse
                            ];
                        case 2:
                            error = _state.sent();
                            esm_exports/* captureMessage */.uT("cs enrichment failed with error: ".concat(error.message || error));
                            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CONTACT_SALES_ENRICHEMNT_CALL_FAILED, {
                                kind: error.message || error
                            });
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(email, timeout) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "isSB", function(companySizeValue, enrichment) {
            var isSMBByForm = companySizeValue === form_constants/* SMALLEST_COMPANY_SIZE */.oP;
            return isSMBByForm && !(enrichment === null || enrichment === void 0 ? void 0 : enrichment.isBC);
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "toggleLoader", function() {
            var _props = _this.props, enableLoader = _props.enableLoader, setLoadingScreen = _props.setLoadingScreen, setLoadingScreenType = _props.setLoadingScreenType, loadingScreenType = _props.loadingScreenType;
            if (!enableLoader) return;
            loadingScreenType !== loader_types/* LOADER_TYPES.BOOK_A_MEETING */.M.BOOK_A_MEETING && setLoadingScreenType(loader_types/* LOADER_TYPES.BOOK_A_MEETING */.M.BOOK_A_MEETING);
            setLoadingScreen(function(isLoading) {
                return !isLoading;
            });
        });
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "handlePostSubmission", function() {
            var _ref = _async_to_generator(function(formData, companySizeValue) {
                var _props, bookAMeetingFlowUrl, contactDetailsUrl, urlToRedirectAfterSubmission, urlToRedirectAfterSubmissionForSmallBusinesses, isBAMDisabled, bamTimeout, extraFields, enrichment, _tmp, redirectUrl, _extraFields, _extraFields1, contactDetails, contactDetailsRedirectUrl, contactDetailsHubspotFields;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _props = _this1.props, bookAMeetingFlowUrl = _props.bookAMeetingFlowUrl, contactDetailsUrl = _props.contactDetailsUrl, urlToRedirectAfterSubmission = _props.urlToRedirectAfterSubmission, urlToRedirectAfterSubmissionForSmallBusinesses = _props.urlToRedirectAfterSubmissionForSmallBusinesses, isBAMDisabled = _props.isBAMDisabled, bamTimeout = _props.bamTimeout;
                            extraFields = [];
                            if (!_this1.enrichmentPromiseRef) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this1.enrichmentPromiseRef
                            ];
                        case 1:
                            _tmp = _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            _tmp = null;
                            _state.label = 3;
                        case 3:
                            enrichment = _tmp;
                            redirectUrl = urlToRedirectAfterSubmission;
                            if (!_this1.isSB(companySizeValue, enrichment)) return [
                                3,
                                4
                            ];
                            (0,contact_sales_service/* setAdaOnPage */.$O)(formData);
                            redirectUrl = urlToRedirectAfterSubmissionForSmallBusinesses;
                            (_extraFields = extraFields).push.apply(_extraFields, (0,_to_consumable_array/* default */.Z)((0,contact_sales_service/* getSmallBusinessesHSFields */.Rb)(redirectUrl)));
                            return [
                                3,
                                6
                            ];
                        case 4:
                            if (!(!isBAMDisabled && bookAMeetingFlowUrl)) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                (0,contact_sales_service/* getContactDetails */.Wz)(formData, enrichment === null || enrichment === void 0 ? void 0 : enrichment.cs, bamTimeout)
                            ];
                        case 5:
                            contactDetails = _state.sent();
                            contactDetailsRedirectUrl = (0,contact_sales_service/* getContactDetailsUrl */.It)(bookAMeetingFlowUrl, contactDetailsUrl, contactDetails || {});
                            contactDetailsHubspotFields = (0,contact_sales_service/* getContactDetailsHubspotFields */.P1)(contactDetails || {});
                            (0,contact_sales_service/* handleContactDetailsInfoOnPage */.aC)(contactDetails, formData);
                            (_extraFields1 = extraFields).push.apply(_extraFields1, (0,_to_consumable_array/* default */.Z)(contactDetailsHubspotFields || []));
                            if (contactDetailsRedirectUrl) {
                                redirectUrl = contactDetailsRedirectUrl;
                            }
                            _state.label = 6;
                        case 6:
                            return [
                                2,
                                {
                                    extraFields: extraFields,
                                    redirectUrl: redirectUrl
                                }
                            ];
                    }
                });
            });
            return function(formData, companySizeValue) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this11 = (0,_assert_this_initialized/* default */.Z)(_this);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "sendFormToHubspot", function() {
            var _ref = _async_to_generator(function(formData) {
                var _getValueFromHSFields, _getValueFromHSFields_value, companySizeValue, _fields, _document, _document1, _props, formId, portalId, abTests, cookies, isV13PricingVersion, withPrivacyNotice, source, overrideCampaignId, cloudfrontViewerCountry, externalEventsForSubmit, hubspotFromHiddenField, localeId, preSelectedProduct, referrePage, hiddenDataParams, startTime, convertedData, fields, ref, redirectUrl, extraFields, response, success, errorMessage, _response_errors_, firstErrorType, data, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            companySizeValue = (_getValueFromHSFields_value = (_getValueFromHSFields = (0,hubspot_service/* getValueFromHSFields */.wB)(formData, hubspot_constants/* HUBSPOT_API_COMPANY_SIZE */.h4)) === null || _getValueFromHSFields === void 0 ? void 0 : _getValueFromHSFields.value) !== null && _getValueFromHSFields_value !== void 0 ? _getValueFromHSFields_value : null;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                6
                            ]);
                            _props = _this11.props, formId = _props.formId, portalId = _props.portalId, abTests = _props.abTests, cookies = _props.cookies, isV13PricingVersion = _props.isV13PricingVersion, withPrivacyNotice = _props.withPrivacyNotice, source = _props.source, overrideCampaignId = _props.overrideCampaignId, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, externalEventsForSubmit = _props.externalEventsForSubmit, hubspotFromHiddenField = _props.hubspotFromHiddenField, localeId = _props.localeId, preSelectedProduct = _props.preSelectedProduct;
                            referrePage = ((_document = document) === null || _document === void 0 ? void 0 : _document.referrer) ? (0,url.extractPathFromUrl)((_document1 = document) === null || _document1 === void 0 ? void 0 : _document1.referrer) : null;
                            hiddenDataParams = (0,hubspot_service/* generateHiddenData */.OB)({
                                withPrivacyNotice: withPrivacyNotice,
                                source: source,
                                overrideCampaignId: overrideCampaignId,
                                abTests: abTests,
                                cookies: cookies,
                                cloudfrontViewerCountry: cloudfrontViewerCountry,
                                referrePage: referrePage,
                                hubspotFromHiddenField: hubspotFromHiddenField
                            });
                            startTime = performance.now();
                            _this11.toggleLoader();
                            convertedData = _this11.convertValuesToHubspotFormat(formData);
                            // Inject preSelectedProduct if provided and ProductQuestionRow is hidden
                            if (preSelectedProduct && preSelectedProduct !== "") {
                                convertedData.push({
                                    name: hubspot_constants/* HUBSPOT_API_PRODUCT_QUESTION */.eo,
                                    value: preSelectedProduct
                                });
                            }
                            fields = (0,_to_consumable_array/* default */.Z)(convertedData).concat((0,_to_consumable_array/* default */.Z)(hiddenDataParams));
                            return [
                                4,
                                _this11.handlePostSubmission(convertedData, companySizeValue)
                            ];
                        case 2:
                            ref = _state.sent(), redirectUrl = ref.redirectUrl, extraFields = ref.extraFields;
                            (_fields = fields).push.apply(_fields, (0,_to_consumable_array/* default */.Z)(extraFields));
                            return [
                                4,
                                (0,hubspot_service/* sendHubspotForm */.Pw)(portalId, formId, fields)
                            ];
                        case 3:
                            response = _state.sent();
                            _this11.sendHubspotStagingFormIfNeeded(portalId, formId, fields);
                            success = response && !response.status; // Success request has no status entry
                            errorMessage = null;
                            if (!success) {
                                ;
                                firstErrorType = (response === null || response === void 0 ? void 0 : response.errors) && (response === null || response === void 0 ? void 0 : (_response_errors_ = response.errors[0]) === null || _response_errors_ === void 0 ? void 0 : _response_errors_.errorType);
                                errorMessage = _this11.getFirstErrorMessageFromResponse(response);
                                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_SUBMIT_FAILED, {
                                    kind: formId,
                                    info1: firstErrorType,
                                    info2: errorMessage
                                });
                            } else {
                                ;
                                try {
                                    data = omit_default()(_object_spread_props(_object_spread({}, mapValues_default()(keyBy_default()(fields, "name"), "value")), {
                                        leadsource: source,
                                        duration: Math.round(performance.now() - startTime)
                                    }), hubspot_constants/* PII_PARAMS */.TO);
                                } catch (e1) {
                                    esm_exports/* captureException */.Tb(e1);
                                }
                                data = _object_spread_props(_object_spread({}, data || {}), {
                                    country: cloudfrontViewerCountry,
                                    language: localeId
                                });
                                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_SUBMIT_CLICKED, {
                                    kind: formId,
                                    info1: companySizeValue,
                                    data: data
                                });
                                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_SUBMIT_SUCCESS, {
                                    kind: formId,
                                    info1: companySizeValue,
                                    data: data
                                });
                                (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).HUBSPOT_FORM_SUBMITTED, {
                                    formId: formId,
                                    lead_data: _this11.convertToLeadData(convertedData)
                                });
                                if (externalEventsForSubmit) {
                                    (0,bigbrain_service.trackEvent)(externalEventsForSubmit.eventType, externalEventsForSubmit.data);
                                }
                            }
                            (0,monetization_ab_tests_service/* enterV13TestIfNeeded */.p)(abTests, cookies, undefined, isV13PricingVersion);
                            !redirectUrl && _this11.toggleLoader();
                            return [
                                2,
                                {
                                    success: success,
                                    errorMessage: errorMessage,
                                    redirectUrl: redirectUrl
                                }
                            ];
                        case 4:
                            e = _state.sent();
                            _this11.toggleLoader();
                            return [
                                4,
                                (0,exceptions_handling_service/* handleClientException */.N)({
                                    e: e,
                                    bbEventParams: {
                                        name: bigbrain_event_types.CONTACT_SALES_FORM_SUBMISSION_FAILED
                                    }
                                })
                            ];
                        case 5:
                            _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(formData) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getSubmitScreenData", function() {
            var overrideCampaignId = _this.props.overrideCampaignId;
            switch(overrideCampaignId){
                case campaigns/* IPO_CAMPAIGN_ID */.Q:
                    return {
                        titleKey: "forms.thanksPage.ipoCampaign.title",
                        subTitleHtmlKey: "forms.thanksPage.ipoCampaign.subTitleHtml"
                    };
                case campaigns/* GARTNER_CAMPAIGN_ID */.S:
                    return {
                        titleKey: "forms.thanksPage.gartnerCampaign.title",
                        subTitleHtmlKey: "forms.thanksPage.gartnerCampaign.subTitleHtml2023",
                        footerHtml: "forms.thanksPage.gartnerCampaign.footerHtml",
                        downloadButtonLink: GARTNER_REPORT_URL
                    };
                default:
                    return null;
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onInputBlur", function(name, value) {
            var formId = _this.props.formId;
            if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_INPUT_TYPED, {
                    kind: formId,
                    info1: name,
                    info2: value === null || value === void 0 ? void 0 : value.length
                });
            }
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_INPUT_BLUR, {
                kind: formId,
                info1: name,
                info2: value === null || value === void 0 ? void 0 : value.length
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "handleFirstFormSubmit", function() {
            _this.setState({
                firstFormSubmitted: true
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "handleBackButtonClicked", function() {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CONTACT_SALES_BACK_BUTTON_CLICKED);
            _this.setState({
                firstFormSubmitted: false
            });
        });
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onEmailChange", function() {
            var _ref = _async_to_generator(function(email) {
                var sendEmailToEnrichment;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    sendEmailToEnrichment = _this2.props.sendEmailToEnrichment;
                    _this2.enrichmentPromiseRef = sendEmailToEnrichment && _this2.getCSData(email);
                    return [
                        2
                    ];
                });
            });
            return function(email) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.enrichmentPromiseRef = null;
        _this.state = {
            firstFormSubmitted: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(HubspotContactForm, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var formId = this.props.formId;
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_READY, {
                    kind: formId
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, withPrivacyNotice = _props.withPrivacyNotice, formId = _props.formId, overrideCampaignId = _props.overrideCampaignId, backgroundLayers = _props.backgroundLayers, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser, formTitle = _props.formTitle, lastNameFirst = _props.lastNameFirst, formSubTitle = _props.formSubTitle, isV2 = _props.isV2, dontRenderPostFormSubmit = _props.dontRenderPostFormSubmit, restProps = _props.restProps, privacyNoticeText = _props.privacyNoticeText, ctaProps = _props.ctaProps, preSelectedProduct = _props.preSelectedProduct;
                var firstFormSubmitted = this.state.firstFormSubmitted;
                var formConfig = (0,contact_form_config/* getContactFormConfigById */.Ty)({
                    formId: formId,
                    overrideCampaignId: overrideCampaignId,
                    withPrivacyNotice: withPrivacyNotice,
                    formTitle: formTitle,
                    lastNameFirst: lastNameFirst,
                    isV2: isV2,
                    firstFormSubmitted: firstFormSubmitted,
                    privacyNoticeText: privacyNoticeText,
                    ctaProps: ctaProps,
                    preSelectedProduct: preSelectedProduct
                });
                var submitScreenData = this.getSubmitScreenData();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hubspot-contact-form-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_form/* default */.Z, {
                        backgroundLayers: isMobileOrTabletBrowser ? 0 : backgroundLayers,
                        formConfig: formConfig,
                        submitFormAsyncCallback: this.sendFormToHubspot,
                        submitScreenData: submitScreenData,
                        onInputBlur: this.onInputBlur,
                        renderPrivacyNotice: withPrivacyNotice,
                        dontRenderPostFormSubmit: dontRenderPostFormSubmit,
                        isV2: isV2,
                        handleFirstFormSubmit: this.handleFirstFormSubmit,
                        handleBackButtonClicked: this.handleBackButtonClicked,
                        firstFormSubmitted: firstFormSubmitted,
                        restProps: restProps,
                        formSubTitle: formSubTitle,
                        onEmailChange: this.onEmailChange
                    })
                });
            }
        }
    ]);
    return HubspotContactForm;
}(react.PureComponent);
HubspotContactForm.defaultProps = default_props/* default */.Z;
/* harmony default export */ var hubspot_contact_form = ((0,system_config_context/* withSystemConfig */.R)((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)((0,loading_screen_context/* withLoadingContext */.Qo)(HubspotContactForm)))));


/***/ }),

/***/ 25279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I4": function() { return /* binding */ AMANDA_TIMOUT; },
/* harmony export */   "S": function() { return /* binding */ PARAM_FROM_VALUE; },
/* harmony export */   "VP": function() { return /* binding */ EMAIL_FOR_HUBSPOT_AMANDA_REQUEST; },
/* harmony export */   "Y4": function() { return /* binding */ PARAM_FROM_KEY; },
/* harmony export */   "c_": function() { return /* binding */ AMANDA_HS_PORTAL_ID; },
/* harmony export */   "eS": function() { return /* binding */ GET_A_CALL_IMG; },
/* harmony export */   "ey": function() { return /* binding */ GET_A_CALL_TIMEOUT_KEY; },
/* harmony export */   "hl": function() { return /* binding */ MINIMUM_FETCH_REQUEST_LOADING_TIME_MS; },
/* harmony export */   "kM": function() { return /* binding */ GET_A_CALL_ALT; },
/* harmony export */   "nS": function() { return /* binding */ AMANDA_CALL_LINK; },
/* harmony export */   "sX": function() { return /* binding */ GET_A_CALL_TIMESTAMP_KEY; },
/* harmony export */   "uE": function() { return /* binding */ AMANDA_HS_FORM_ID; },
/* harmony export */   "wc": function() { return /* binding */ BOOK_A_MEETING_IMG; },
/* harmony export */   "ys": function() { return /* binding */ DEFAULT_TIMEOUT_VALUE; },
/* harmony export */   "zN": function() { return /* binding */ BOOK_A_MEETING_ALT; },
/* harmony export */   "zz": function() { return /* binding */ USER_FIRST_NAME; }
/* harmony export */ });
var GET_A_CALL_IMG = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/contact-sales/Get_Call.svg";
var GET_A_CALL_ALT = "Get a call image";
var BOOK_A_MEETING_IMG = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/contact-sales/Book_Meeting.svg";
var BOOK_A_MEETING_ALT = "Book a meeting image";
var PARAM_FROM_KEY = "from";
var PARAM_FROM_VALUE = "amanda";
var DEFAULT_TIMEOUT_VALUE = 600000;
var GET_A_CALL_TIMEOUT_KEY = "getACallTimeout";
var GET_A_CALL_TIMESTAMP_KEY = "getACallTimestamp";
var AMANDA_CALL_LINK = "amandaCallLink";
var AMANDA_TIMOUT = "amandaCallLinkExpirationInMS";
var EMAIL_FOR_HUBSPOT_AMANDA_REQUEST = "userEmailForAmanda";
var USER_FIRST_NAME = "userFirstName";
var AMANDA_HS_FORM_ID = "39feff83-3d21-49c2-be03-4961de873f82";
var AMANDA_HS_PORTAL_ID = "5945317";
var MINIMUM_FETCH_REQUEST_LOADING_TIME_MS = 2000;


/***/ })

}]);